import EditWorkCycle from './EditWorkCycle';

export default EditWorkCycle;